var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-select',{attrs:{"placeholder":_vm.placeholder,"name":_vm.name,"id":_vm.name,"is-multiple":_vm.isMultiple,"use-search":_vm.useSearch,"options":_vm.options},on:{"input":_vm.onChange,"submit":_vm.onSubmit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }